import App from './modules/App'
import CheckoutV2 from './components/checkout/CheckoutV2'
import AddressFillFormManager from './components/checkout/AddressFillFormManager'
import CountryManager from './components/checkout/CountryManager'
import PanelManager from './components/PanelManager'
import PopupMessage from './components/PopupMessage'
import CatFilterManager from './components/CatFiltermanager'

document.addEventListener('DOMContentLoaded', () => {
    new App()

    let root = {}
    root.checkoutV2 = new CheckoutV2(root, [])
    root.checkoutV2.run()
    root.addressFillFormManager = new AddressFillFormManager(root, [])
    root.addressFillFormManager.run()
    root.countryManager = new CountryManager(root, [])
    root.countryManager.run()
    root.panelManager = new PanelManager(root, [])
    root.panelManager.run()
    root.popupMessage = new PopupMessage(root, [])
    root.popupMessage.run()
    root.catFilterManager = new CatFilterManager(root, [])
    root.catFilterManager.run()
}, false)


window.onscroll = function () {
  const navbar = document.querySelector('.navbar');
  if (window.pageYOffset > 0) {
    navbar.classList.add('scrolled');
  } else {
    navbar.classList.remove('scrolled');
  }
};

// const loginButton = document.getElementById('login-button');
// const loginForm = document.getElementById('login-form');

// loginButton.addEventListener('click', () => {
//   loginForm.style.display = 'block';
// });


// const closeButton = document.getElementById('close-button');
// closeButton.addEventListener('click', () => {
//   loginForm.style.display = 'none';
// });

// document.addEventListener('click', (event) => {
//   if (event.target === loginForm) {
//     loginForm.style.display = 'none';
//   }
// });

//paralax 3 imagens
window.addEventListener("scroll", function () {
  var posicao = this.pageYOffset;

  var images = document.querySelectorAll(".imagem");
  images.forEach(function (image) {
    var speed = image.getAttribute("data-index");
    var top = image.getAttribute("data-top");
    image.style.top = -(((posicao / 2) - top) * speed) + "px";
  });
});

// //linguas
// const dropdownBtn = document.querySelector('.dropdown-btn');
// const dropdownContent = document.querySelector('.dropdown-content');

// dropdownBtn.addEventListener('click', function() {
//   dropdownContent.classList.toggle('show');
// });

(function() {
  //slides
  const slides = document.querySelectorAll('.bg-image');
  let currentSlide = 0;

  if (0 === slides.length) {
    return;
  }

  function nextSlide() {
    // Remove a classe "active" da imagem atual
    slides[currentSlide].classList.remove('active');

    // Atualiza o índice da imagem atual
    currentSlide = (currentSlide + 1) % slides.length;

    // Adiciona a classe "active" na próxima imagem
    slides[currentSlide].classList.add('active');
  }

  // Executa a função "nextSlide" a cada 5 segundos
  setInterval(nextSlide, 5000);
})();

(function() {
  //paralax slide
  // Obtém todas as imagens do slide
  const images = document.querySelectorAll('.bg-image');

  if (0 === images.length) {
    return;
  }

  // Adiciona um evento de scroll à página
  window.addEventListener('scroll', function() {
    // Obtém a posição atual do scroll da página
    const scrollTop = window.pageYOffset;

    // Itera por todas as imagens
    images.forEach(function(image) {
      // Atualiza a posição de fundo da imagem de acordo com a posição do scroll
      image.style.backgroundPositionY = scrollTop * 0.5 + 'px';
    });
  });
})();

(function() {
  //paralax categorias
  // Obtém todas as imagens do slide
  const imagemctg = document.querySelectorAll('.image-categoria');

  if (0 === imagemctg.length) {
    return;
  }

  // Adiciona um evento de scroll à página
  window.addEventListener('scroll', function() {
    // Obtém a posição atual do scroll da página
    const scrollTop = window.pageYOffset;

    // Itera por todas as imagens
    imagemctg.forEach(function(image) {
      // Atualiza a posição de fundo da imagem de acordo com a posição do scroll
      image.style.backgroundPositionY = scrollTop * 0.5 + 'px';
    });
  });
})();

(function() {
  //galleria de produto
  const els = document.querySelectorAll("[type='radio']");

  if (0 === els.length) {
    return;
  }

  for (const el of els) {
    el.addEventListener("input", e => reorder(e.target, els));
  }
  reorder(els[0], els);

  function reorder(targetEl, els) {
    const nItems = els.length;
    let processedUncheck = 0;
    for (const el of els) {
      const containerEl = el.nextElementSibling;
      if (el === targetEl) {//checked radio
        containerEl.style.setProperty("--w", "100%");
        containerEl.style.setProperty("--l", "0");
      }
      else {//unchecked radios
        containerEl.style.setProperty("--w", `${100/(nItems-1)}%`);
        containerEl.style.setProperty("--l", `${processedUncheck * 100/(nItems-1)}%`);
        processedUncheck += 1;
      }
    }
  }
})();